import React from 'react';
import ScreenListing from '../components/ScreenListing';

export default (props) => {
  const { data } = props;

  return (
    <>
      <ScreenListing
        {...props}
        datalist={data?.bill_screen_list}
        buttonType={"bill_function_screen"}
      />
    </>
  )
}